// Client-side mirror of the upload contexts in server/config/uploads.php:
// keep both sides aligned when limits or accepted types change.
export const UPLOAD_MAX_BYTES = 10_000_000;

export const UPLOAD_MAX_MEGABYTES = 10;

// Profile photo (registration and account update). Other uploads keep UPLOAD_MAX_BYTES.
export const PROFILE_PHOTO_MAX_BYTES = 2_000_000;

export const PROFILE_PHOTO_MAX_MEGABYTES = 2;

export const ACCEPTED_IMAGE_MIMES = "image/png,image/jpeg";

export const ACCEPTED_DOCUMENT_MIMES = "image/png,image/jpeg,application/pdf";

export const isFileTooLarge = (file: { size: number }): boolean => file.size > UPLOAD_MAX_BYTES;
